import { IAPIResponse, IHTTPResponse } from "../models/httpModels";

export const getErrorMessage = (res: IHTTPResponse<IAPIResponse<any>>): string => {

    if (res?.data?.errors?.length > 0) {
        let errorMessage = "";
        res?.data?.errors.forEach((i) => {
            if (errorMessage !== "") {
                errorMessage += "\n";
            }
            errorMessage += i.field + " : " + i.message;
        });
        return errorMessage;
    }
    return '';
}

export const hasAnyErrors = (res: IHTTPResponse<IAPIResponse<any>>): boolean => {
    return res?.data?.errors?.length > 0;
}